
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.2 10.8c-1-1.3-2.3-2.8-3.7-4.2C30.1 5.2 28.7 4 27.4 3c.2-.6-.1-1.3-.7-1.8l-8 8c.4.4 1.1.6 1.6.6.7 1 1.6 2.1 2.7 3.2l-8.6 8.6 1.8 1.8 8.6-8.6c1.2 1.1 2.4 2.2 3.5 3-.1.6.1 1.2.6 1.6l8-8c-.5-.5-1.1-.7-1.7-.6zM30 32.8l4.7-2.9c-1.3-.6-2.9-.5-4.2.3l-3.9 2.4h.4l3 .2zM33.8 34.9l.6-.3 5.6-3.3c-1-.4-2.2-.5-3.2-.1l-.9.6-3.1 1.9c.4.2.8.6 1 1.2z"}}),_c('path',{attrs:{"d":"M44.7 30.9c-.3 0-.6.1-.9.2l-1 .6L34 37c-.3 1.6-1.7 2.7-3.5 2.7h-7.6c-1.4 0-2.7-.2-4-.7l-1.9-.6.3-.8.4-1.1 1.9.7c1.1.4 2.2.5 3.3.5h7.6c.8 0 1.5-.6 1.5-1.4 0-.4-.2-.8-.5-1-.2-.2-.5-.3-.9-.3l-3.7-.1h-.5c-1.7-.2-3-1-4.2-1.8l-2.1-1.5c-3.4-2.4-7.9-2.6-11.4-.5L3 34.4 7.6 44l3.2-1.9c.9-.6 1.9-.7 2.9-.3l9.8 4.1c.7.3 1.5.5 2.2.5 1.1 0 2.2-.3 3.1-.9l17.1-10.9c.6-.4.8-.9.8-1.7v-.1c0-1-.9-1.9-2-1.9z"}})])
          )
        }
      }
    